import { Button, Checkbox, message, Modal } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import AccessControlAction from '../../components/AccessControlAction'
import RichEditor from '../../components/RichEditor/RichEditor'
import { ACL_ACTION_TYPE } from '../../constants'

const MissionItemDetailUpdateModalV2 = props => {
  const {
    open,
    setOpen,
    resultTask,
    taskStore,
    files,
    missionId,
    setIsUpdateMissionDetail,
    isUpdateMissionDetail,
    onUpdateSuccess,
    isHideAction = false,
  } = props

  const [percentCompleteUpdate, setPercentCompleteUpdate] = useState(0)
  const [editorContentResult, setEditorContentResult] = useState('')
  const [editorKienNghi, setEditorKienNghi] = useState('')
  const [editorCanhBao, setEditorCanhBao] = useState('')
  const [editorDiemNghen, setEditorDiemNghen] = useState('')
  const [editorDeXuat, setEditorDeXuat] = useState('')

  const [isUpdating, setIsUpdating] = useState(false)

  const CONTENT_RESULT_REF = useRef(null)
  const KIEN_NGHI_REF = useRef(null)
  const CANH_BAO_REF = useRef(null)
  const DIEM_NGHEN_REF = useRef(null)
  const DE_XUAT_REF = useRef(null)

  useEffect(() => {
    setPercentCompleteUpdate(
      resultTask.phan_tram_hoan_thanh
        ? parseInt(resultTask.phan_tram_hoan_thanh, 10)
        : 0
    )
    setEditorContentResult(resultTask.noi_dung_ket_qua_giao || '')
    setEditorKienNghi(resultTask.kien_nghi || '')
    setEditorCanhBao(resultTask.canh_bao || '')
    setEditorDiemNghen(resultTask.diem_nghen || '')
    setEditorDeXuat(resultTask.de_xuat || '')
  }, [resultTask])

  const handleUpdateMission = useCallback(async () => {
    const currentNoiDungKetQua = CONTENT_RESULT_REF.current
      ? CONTENT_RESULT_REF.current.editor.getData()
      : ''
    const currentKienNghi = KIEN_NGHI_REF.current
      ? KIEN_NGHI_REF.current.editor.getData()
      : ''
    const currentCanhBao = CANH_BAO_REF.current
      ? CANH_BAO_REF.current.editor.getData()
      : resultTask.canh_bao || ''
    const currentDiemNghen = DIEM_NGHEN_REF.current
      ? DIEM_NGHEN_REF.current.editor.getData()
      : resultTask.diem_nghen || ''
    const currentDeXuat = DE_XUAT_REF.current
      ? DE_XUAT_REF.current.editor.getData()
      : resultTask.de_xuat || ''
    const currentPhanTram = percentCompleteUpdate

    const initialPhanTram = resultTask.phan_tram_hoan_thanh
      ? parseInt(resultTask.phan_tram_hoan_thanh, 10)
      : 0
    const initialNoiDungKetQua = resultTask.noi_dung_ket_qua_giao || ''
    const initialKienNghi = resultTask.kien_nghi || ''
    const initialCanhBao = resultTask.canh_bao || ''
    const initialDiemNghen = resultTask.diem_nghen || ''
    const initialDeXuat = resultTask.de_xuat || ''

    if (
      currentPhanTram === initialPhanTram &&
      currentNoiDungKetQua === initialNoiDungKetQua &&
      currentKienNghi === initialKienNghi &&
      currentCanhBao === initialCanhBao &&
      currentDiemNghen === initialDiemNghen &&
      currentDeXuat === initialDeXuat
    ) {
      message.info('Không có giá trị nào thay đổi !!')
      return
    }

    try {
      const submitData = {
        kien_nghi: currentKienNghi,
        noi_dung_ket_qua: currentNoiDungKetQua,
        canh_bao: currentCanhBao,
        diem_nghen: currentDiemNghen,
        de_xuat: currentDeXuat,
        ty_le_hoan_thanh: currentPhanTram,
        files: files.map(file => file.file_id),
      }
      setIsUpdating(true)
      await taskStore.updateTask(missionId, submitData)

      if (setIsUpdateMissionDetail) {
        setIsUpdateMissionDetail(!isUpdateMissionDetail)
      }

      await Promise.all([
        taskStore.getTaskList(),
        taskStore.getTaskDetail(missionId),
      ])

      if (onUpdateSuccess) {
        onUpdateSuccess()
      }

      message.success('Cập nhật nhiệm vụ thành công!')
      setOpen(false)
    } catch (err) {
      message.error(err?.vi || 'Đã có lỗi xảy ra')
    } finally {
      setIsUpdating(false)
    }
  }, [
    percentCompleteUpdate,
    resultTask,
    files,
    missionId,
    taskStore,
    setIsUpdateMissionDetail,
    isUpdateMissionDetail,
    onUpdateSuccess,
    setOpen,
  ])

  return (
    <Modal
      style={{
        top: 20,
      }}
      title="Cập nhật thông tin nhiệm vụ"
      open={open}
      onCancel={() => {
        setOpen(false)
      }}
      footer={null}
      wrapClassName="custom-modal-wrapper"
      width={900}>
      <>
        <dt style={{ display: 'inline-block', marginRight: 16, marginTop: 16 }}>
          Trạng thái:
        </dt>
        <dd style={{ display: 'inline-block' }}>
          <Checkbox
            checked={percentCompleteUpdate === 100}
            onChange={e =>
              setPercentCompleteUpdate(e.target.checked ? 100 : 0)
            }>
            Hoàn thành
          </Checkbox>
        </dd>

        <dt>Nội dung kết quả</dt>
        <div style={{ width: '100%', marginBottom: 16 }}>
          <RichEditor
            EDITOR_REF={CONTENT_RESULT_REF}
            placeholder="Nhập nội dung kết quả..."
            editorContent={editorContentResult}
          />
        </div>

        <dt>Kiến nghị</dt>
        <div style={{ width: '100%', marginBottom: 16 }}>
          <RichEditor
            EDITOR_REF={KIEN_NGHI_REF}
            placeholder="Nhập nội dung kết quả..."
            editorContent={editorKienNghi}
          />
        </div>

        <AccessControlAction
          aclActionType={ACL_ACTION_TYPE.canh_bao__MISSION}
          fallback={null}>
          <dt>Cảnh báo</dt>
          <div style={{ width: '100%', marginBottom: 16 }}>
            <RichEditor
              EDITOR_REF={CANH_BAO_REF}
              placeholder="Nhập cảnh báo..."
              editorContent={editorCanhBao}
            />
          </div>
        </AccessControlAction>

        <AccessControlAction
          aclActionType={ACL_ACTION_TYPE.diem_nghen__MISSION}
          fallback={null}>
          <>
            <dt>Điểm nghẽn</dt>
            <div style={{ width: '100%', marginBottom: 16 }}>
              <RichEditor
                EDITOR_REF={DIEM_NGHEN_REF}
                placeholder="Nhập điểm nghẽn..."
                editorContent={editorDiemNghen}
              />
            </div>
          </>
        </AccessControlAction>
        <AccessControlAction
          aclActionType={ACL_ACTION_TYPE.de_xuat__MISSION}
          fallback={null}>
          <>
            <dt>Đề xuất</dt>
            <div style={{ width: '100%', marginBottom: 16 }}>
              <RichEditor
                EDITOR_REF={DE_XUAT_REF}
                placeholder="Nhập đề xuất..."
                editorContent={editorDeXuat}
              />
            </div>
          </>
        </AccessControlAction>

        <div
          style={{
            width: '100%',
            display: isHideAction ? 'none' : 'flex',
            flexWrap: 'nowrap',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <Button danger onClick={() => setOpen(false)}>
            Hủy
          </Button>
          <Button
            type="primary"
            loading={isUpdating}
            onClick={handleUpdateMission}>
            Lưu lại
          </Button>
        </div>
      </>
    </Modal>
  )
}

export default inject(
  'taskStore',
  'loadingAnimationStore',
  'authenticationStore',
  'fileStore',
  'selectPeopleStore'
)(observer(MissionItemDetailUpdateModalV2))
